import HttpClient from '@/services/HttpClient';
import store from '@/store';

export default class PaymentPlanService {
	constructor() {
		this.httpClient = new HttpClient();
	}

	getPaymentPlans() {
		return this.httpClient.get(`/${store.getters.getClientId}/paymentPlans`);
	}
}
